// extracted by mini-css-extract-plugin
export default {"sizes":"Sizes_sizes__mXxYe","checkmark":"Sizes_checkmark__07xgc","fs-smaller":"Sizes_fs-smaller__lT+YT"};